<template>
  <div class="flex flex-col">
    <h3 class="body-1-bold mb-16">
      {{ i18n(translations.subtitle) }}
    </h3>

    <RevListItemStatic
      class="border-static-default-low cursor-pointer border-b-1"
      data-qa="product-out-of-stock"
      @click="$emit('select-issue', ISSUES.OUT_OF_STOCK)"
    >
      <template #label>
        {{ i18n(translations.productOutOfStock) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemStatic>

    <RevListItemStatic
      v-if="showDeliveryIssue"
      class="border-static-default-low cursor-pointer border-b-1"
      data-qa="issue-with-delivery"
      @click="$emit('select-issue', ISSUES.DELIVERY_ISSUE)"
    >
      <template #label>
        {{ i18n(translations.issueWithDelivery) }}
      </template>
      <template #description>
        {{ i18n(translations.deliveryIssueDescription) }}
      </template>

      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemStatic>

    <RevListItemStatic
      class="cursor-pointer"
      data-qa="other-issue"
      @click="$emit('select-issue', ISSUES.OTHER_ISSUE)"
    >
      <template #label>
        {{ i18n(translations.otherIssue) }}
      </template>
      <template #suffix>
        <IconChevronRight />
      </template>
    </RevListItemStatic>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevListItemStatic } from '@ds/components/ListItemStatic'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { ISSUES } from '../../FixOrderIssueDrawer.constants'
import type { ISSUE_TYPES } from '../../FixOrderIssueDrawer.types'

import translations from './IssuesChoices.translations'

defineProps<{
  showDeliveryIssue: boolean
}>()

const i18n = useI18n()

defineEmits<{
  (e: 'select-issue', issueType: ISSUE_TYPES): void
}>()
</script>
